export enum OrderType {
  DineIn = "DINE_IN",
  Pickup = "PICKUP",
}
